import { RedRobinApiService } from '@api_patient/red_robin_api.service';
import { AnalyticCategories, AnalyticService } from '@application/analytic/analytic.service';
import { RouterService } from '@cortex-shim/router.service';
import { getAbsoluteRoute } from '@module/get_absolute_route';
import { signal } from '@preact/signals-react';
import { ControllerProtocol, Injectable, Scopes } from '@visiba/instantiation';
import type { State } from 'history';
import { RedRobinScreen, ViewRedRobinAnalyticActions, ViewRedRobinController } from '../view_red_robin.controller';

@Injectable({
	scope: Scopes.Scoped,
})
export class ScreenRedRobinSessionIframeController implements ControllerProtocol {
	public viewData = signal<PresentationModel>({ sessionUrl: '' });
	constructor(
		private readonly viewRedRobinController: ViewRedRobinController,
		private readonly redRobinApiService: RedRobinApiService,
		public readonly routerService: RouterService,

		private readonly analyticService: AnalyticService,
	) {}

	async whenMount() {
		this.analyticService.trackPageView({
			customTitle: 'RedRobin: Session',
		});

		const sessionId = location.pathname.split('/').pop();
		const linkResult = await this.redRobinApiService.getSessionLink(sessionId ?? 'not-found');
		if (linkResult.err) {
			this.analyticService.trackEvent(AnalyticCategories.RedRobin, ViewRedRobinAnalyticActions.Closed, 'Initial load');
			this.viewRedRobinController.goToScreen(RedRobinScreen.Error, { replace: true });

			return;
		}

		this.viewData.value = {
			sessionUrl: linkResult.ok.data,
		};
	}

	public navigateToExitUrl(url: string, state?: State) {
		// TODO: Remove when angular is gone!
		if (
			(window as typeof window & { __TEMP__overrideNavigation: Record<string, unknown> | undefined })['__TEMP__overrideNavigation'] !=
			null
		) {
			window.location.href = url;

			return;
		}

		const path = new URL(url).pathname.split('/').slice(2).join('/'); // Pathname without licenceholder alias
		this.routerService.navigateByUrl(getAbsoluteRoute(path), { state });
	}
}

interface PresentationModel {
	sessionUrl: string;
}
